import { render, staticRenderFns } from "./Equipaments.vue?vue&type=template&id=2cba750d&"
import script from "./Equipaments.vue?vue&type=script&lang=js&"
export * from "./Equipaments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports